module.exports = __webpack_public_path__ + "img/iso27001-sertika.c5aeff71.png";